import { FieldType } from "wc-lib";

export function insertMissingIntervals(data: any[], intervalTimestampProperty: string, intervalSeconds: number, newIntervalProperties: any): any[] {
  if (data.length === 0) return data;

  let fixedData: any[] = [data[0]];

  let intervalMillis = intervalSeconds * 1000;
  let nextIntervalMillis: number = data[0][intervalTimestampProperty].getTime() + intervalMillis;
  for (let i = 1; i < data.length; i++) {
    while (data[i][intervalTimestampProperty].getTime() > nextIntervalMillis) {
      let newInterval = { ...data[i], ...newIntervalProperties };
      newInterval[intervalTimestampProperty] = new Date(nextIntervalMillis);

      fixedData.push(newInterval);
      nextIntervalMillis += intervalMillis;
    }
    fixedData.push(data[i]);
    nextIntervalMillis = data[i][intervalTimestampProperty].getTime() + intervalMillis;
  }

  return fixedData;
}

// table component has a bug displaying small negative numbers as 0$.00. But rounding to 2 decimal places first fixes this.
export function fixCurrencyFieldsForTable(data: any[], currencyFields: string[]): any[] {
  let fixedData: any[] = [];

  for (let datum of data) {
    let fixedDatum: any = { ...datum };
    for (let currencyField of currencyFields) {
      if (fixedDatum[currencyField] !== undefined && fixedDatum[currencyField] != null) {
        fixedDatum[currencyField] = (new Number(fixedDatum[currencyField].toFixed(2))).valueOf();
      }
    }
    fixedData.push(fixedDatum);
  }

  return fixedData;
}

// table component always displays decimals with 2 decimal places.
// This function makes it display a specified number of decimal places.
export function fixDecimalColumnsForTable(columns: any[], decimalPlaces: number): any[] {
  let fixedColumns: any[] = [];

  for (let column of columns) {
    let fixedColumn: any = { ...column };
    if (column.fieldType === FieldType.Decimal) {
      fixedColumn.formatter = (value) => value !== undefined && value !== null ? value.toFixed(decimalPlaces) : '';
      fixedColumn.fieldType = null;
    }
    fixedColumns.push(fixedColumn);
  }

  return fixedColumns;
}



// WEBPACK FOOTER //
// src/views/electricity/fpp/dataUtils.ts